// extracted by mini-css-extract-plugin
export var center = "PageMargins-module--center--f7+hM";
export var limitWidthOnLargeScreens = "PageMargins-module--limitWidthOnLargeScreens--5oYMl";